module.exports = __webpack_public_path__ + "static/media/csv_format_upload_users.f86b9585.csv";